import CiqLogPageHeader from "components/ciq-log-page-header";
import CiqAgGrid from "components/ciq-ag-grid";
import { TCiqAgGrid, TCiqLogHeader } from "./model";

type Props = {
  headerInfo?: TCiqLogHeader;
  gridInfo: TCiqAgGrid;
  headerComponent?: React.ReactNode;
  additionalGridComponent?: React.ReactNode;
};

function CiqGridViewWrapper({
  gridInfo,
  headerInfo,
  headerComponent,
  additionalGridComponent
}: Props) {
  // import and call from services to pass data and create model instances.
  // import and use model instances here.
  // import ui-configs here and build the generic page.

  return (
    <div className="flex flex-col h-full w-full">
      {headerComponent || (headerInfo && <CiqLogPageHeader {...headerInfo} />)}
      <CiqAgGrid
        {...gridInfo}
        additionalGridComponent={additionalGridComponent}
      />
    </div>
  );
}

export default CiqGridViewWrapper;
